












import { Component, Vue, Prop } from 'vue-property-decorator'
import { EnhancedPost } from '~base/common/types'
import SearchResultItem from '~components/content/post-types/SearchResultItem.vue'

@Component({
  components: {
    SearchResultItem,
  },
})
export default class SearchLayout extends Vue {
  @Prop({ type: Array }) readonly posts!: EnhancedPost[]
  @Prop({ type: Number }) readonly layoutIndex!: number
}
